module.exports = __webpack_public_path__ + "media/img/corporate/hero-4f866228f4edaf2f4defc4f2c8f70701.jpg";